import type { UrlRequest } from '@pba/react-utils';
import axios from 'axios';

export const downloadDropboxFile = async ({ url }: UrlRequest) => axios.get<Blob>(url, { responseType: 'blob' });
